import * as type from './types';

export function deleteMessage(data) {
    return {
        type: type.POST_DELETE_MESSAGE_REQUESTED,
        data: data,
    }
};
